























































import Component from 'vue-class-component';
import authApi from '@/api/auth.api';
import alertsApi from '@/api/alerts.api';
import accountsApi from '@/api/accounts.api';
import captchaApi from '@/api/captcha.api';
import { FormComponent } from '@/components/base/form/form.component';
import { IFormControl } from '@/entities/form.interface';
import { IDictionary } from '@/entities/dictionary.interface';
import { IConfirm, MeModel } from '@/entities';
import * as types from '@/store/types';
import authService from '@/services/auth.service';
import { whiteLabel } from '../../services/config/config.service';

@Component({})
export default class LoginPage extends FormComponent {
    public whiteLabel = whiteLabel;
    public brand = process.env.VUE_APP_BRAND;

    public formState: IDictionary<IFormControl> = {
        username: {
            key: 'username',
            label: 'Username',
            value: '',
            validators: 'required'
        },
        password: {
            key: 'password',
            label: 'Password',
            value: '',
            validators: 'required'
        },
        captchaSrc: {
            key: 'captchaSrc',
            label: '',
            value: '',
            validators: ''
        },
        captchaString: {
            key: 'captchaString',
            label: '',
            value: '',
            validators: ''
        },
        captchaCheck: {
            key: 'captchaCheck',
            label: '',
            value: '',
            validators: ''
        }
    };
    public useCaptcha = Boolean(Number(process.env.VUE_APP_USE_CAPTCHA));

    public created() {
        this.loadCaptcha();
    }

    public loadCaptcha() {
        captchaApi
            .image()
            .then((captcha) => {
                this.formState.captchaSrc.value = captcha.image;
                this.formState.captchaCheck.value = captcha.check;
                this.formState.captchaString.value = '';
            })
            .catch((err) => this.processError(err));
    }

    public login() {
        this.loading = true;

        let username = this.formState.username.value;
        let password = this.formState.password.value;
        let captchaString = this.formState.captchaString.value;
        let captchaCheck = this.formState.captchaCheck.value;

        authApi
            .login({
                username,
                password,
                captchaString,
                captchaCheck
            })
            .then((res: { token: string }) => {
                authService.processLoginSuccess(this.$store, res.token);
                this.loading = false;

                const returnUrl = this.$route.query.returnUrl
                    ? this.$route.query.returnUrl
                    : '/app/home';

                this.$router.push(returnUrl);
            })
            .catch((err) => {
                this.loadCaptcha();
                this.processError(err);
            });
    }

    public submit() {
        this.login();
    }
}
